module.exports = __webpack_public_path__ + "img/bfc1a91.9a75695b.jpg";